<script setup lang="ts">
const auth = useAuth()
</script>

<template>
  <DashboardSpotlightSearch v-if="auth.authenticated.value && auth.tenant.value" />
</template>
